import React, { useState } from 'react'
import AdminTitle from '../../../common/AdminTitle/AdminTitle'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom'
import CollectionForm from './CollectionForm'
import { useCreateCollectionMutation } from '../../../api/collection.api';

const CollectionAdd = () => {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [createCollection] = useCreateCollectionMutation()

    const submitEvent = async (data) => {
        setLoading(true);
        try {
            // Set up FormData to handle file upload
            const formData = new FormData();
            formData.append("name", data.name);
            formData.append("description", data.description || "");  
            formData.append("status", data.status.value); 
            formData.append("category", data.category.value);

            // Append image or video file
            if (data.image instanceof File) {
                formData.append("image", data.image);
            }
            if (data.video instanceof File) {
                formData.append("video", data.video);
            }

            await createCollection(formData).unwrap();            
            toast.success("Collection Created Successfully");
            navigate("/dashboard/collection");             
        } catch (exception) {
            let errorMessage = "Error while creating collection";

            if (exception.data) {
                const data = exception.data;
                if (data.result) {
                    errorMessage = Object.values(data.result).join(", ");
                } else if (data.message) {
                    errorMessage = data.message;
                }
            }

            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='admin_margin_box'>
            <ToastContainer />
            <div className="admin_titles">
                <AdminTitle label1=" Collection List" label2="/Add Collection" url="/dashboard/collection" />
                <div className='Dashboard_title'>
                    <h1>Add Collection</h1>
                </div>
            </div>

            <div className="banner_form">
               <CollectionForm submitEvent={submitEvent} loading={loading} value="Add Collection" />
            </div>
        </div>
    )
}

export default CollectionAdd